import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

import type { CategorySettingsProps } from './types'

export const CategorySettings = ({
  category,
  onEdit,
  onToggleEnabled,
  onDelete,
}: CategorySettingsProps) => {
  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="left" align="end">
        <PopoverMenu.TouchableOption
          icon={'pencil'}
          title={i18n.t('common.edit')}
          onClick={() => onEdit(category)}
        />
        <PopoverMenu.TouchableOption
          icon={category.enabled ? 'eye-invisible' : 'eye-visible'}
          title={
            category.enabled
              ? i18n.t('app_store_v2.apps.complaints.settings.categories.options.disable_option')
              : i18n.t(
                  'app_store_v2.apps.complaints.settings.categories.category_visible_to_employees'
                )
          }
          onClick={() => onToggleEnabled(category)}
        />
        <PopoverMenu.TouchableOption
          danger
          icon={'delete'}
          title={i18n.t('common.delete')}
          onClick={() => onDelete(category)}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}
